var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5524 14.8422L15.3585 8.64832C15.0049 8.29476 15.007 7.72089 15.3631 7.36991C15.7156 7.02249 16.2824 7.02455 16.6323 7.3745L24.2929 15.0351C24.6834 15.4256 24.6834 16.0588 24.2929 16.4493L16.6323 24.1099C16.2824 24.4598 15.7156 24.4619 15.3631 24.1145C15.007 23.7635 15.0049 23.1896 15.3585 22.8361L21.5524 16.6422L7.89997 16.6422C7.40293 16.6422 7 16.2392 7 15.7422C7 15.2451 7.40293 14.8422 7.89997 14.8422L21.5524 14.8422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.78cc4dd70684511b07f5f3194749df0f.svg";
export { ForwardRef as ReactComponent };